import { createFileRoute } from "@tanstack/react-router";
import { SurfacePage } from "@/content-site/components/surface-page";
import { loadContentPage, contentHead } from "@/content-site/lib/page";
export const Route = createFileRoute("/_content/feature/")({
  loader: () => loadContentPage(["feature"]),
  head: ({ loaderData }) => contentHead(loaderData),
  component: Page,
});
function Page() {
  return <SurfacePage data={Route.useLoaderData()} />;
}
